export default "__VITE_ASSET__b3ca39b6__"